export default "__VITE_ASSET__Dazj4OWx__"